import {CSSProperties} from "react";
import {Tooltip} from "@mui/material";
import {describeEffectiveScore, describeWorth, EffectiveScore} from "../utils/scoreFormula";

// Read-only companion row of a Player Score field: what the entity is worth IN GAME once
// its kind's Score Formula (General tab) has had its say. Laid out like the labelled
// inputs around it — label left, a read-only box in the input column — so the value sits
// under the field it belongs to. The field stays the designer's; this never writes it.
// Hover the label for where the number comes from.
function ScoreReadout(props: { effective: EffectiveScore, style?: CSSProperties }) {
    return (
        <div className={'layout horizontal stretch gap'} style={{...{alignItems: 'center', gap: 10}, ...props.style}}>
            <Tooltip title={describeEffectiveScore(props.effective)} arrow disableInteractive>
                <p className={'muted-text'} style={{cursor: 'help'}}>Score by Formula</p>
            </Tooltip>
            <input readOnly tabIndex={-1} value={describeWorth(props.effective)}
                   style={{color: 'var(--muted-text-color)', borderColor: 'transparent', cursor: 'default'}}/>
        </div>
    );
}

export default ScoreReadout;
